import { Typography } from '@ywwwtseng/tma-react-kit';
import { InViewport } from './InViewport';

interface ListProps<T> {
  className?: string;
  fallback?: React.ReactNode;
  data?: T[];
  title?: React.ReactNode;
  children: (item: T) => React.ReactNode;
  noDataLabel?: string;
  showEmptyView?: boolean;
  onScrollEnd?: () => void;
}

export function List<T>({
  className,
  fallback,
  title,
  data,
  children,
  noDataLabel,
  showEmptyView = true,
  onScrollEnd,
}: ListProps<T>) {
  const onInView = () => {
    onScrollEnd?.();
  };

  if (!data) {
    if (fallback) {
      return <div className={className}>{fallback}</div>;
    }

    return null;
  }

  if (showEmptyView && data.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center w-full h-full">
        <img
          className="w-[150px] object-contain"
          src="/images/zap.png"
          alt="zap"
        />
        <Typography
          size="2"
          weight={600}
          i18n={noDataLabel ?? 'common.no_data'}
        />
      </div>
    );
  }

  return (
    <div className={className}>
      {title}
      {data.map((item) => children(item))}
      <InViewport onInView={onInView} />
    </div>
  );
}
